<template>
  <v-tooltip
    :disabled="!isRoleUser"
    class="ml-2"
    bottom
  >
    <template slot="activator">
      <slot :isDisabledForUser="isRoleUser"/>
    </template>
    <span>{{ $t('pleaseSignUp') }}</span>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DisabledUserButton',
  computed: {
    ...mapGetters('user', ['getUser']),
    isRoleUser () {
      return this.getUser.role === 'user'
    }
  },
  i18n: {
    messages: {
      en: {
        pleaseSignUp: 'This is a demo version, please subscribe to use it'
      },
      tr: {
        pleaseSignUp: 'Bu bir demo versiyondur, kullanmak için lütfen üye olunuz'
      },
      de: {
        pleaseSignUp: 'Dies ist eine Demoversion, zur Nutzung bitte ein Abonnement abschließen'
      },
      ru: {
        pleaseSignUp: 'Это демонстрационная версия, пожалуйста, оплатите подписку, чтоб использовать весь функционал.'
      }
    }
  }
}
</script>
